




































import { defineComponent } from '@vue/composition-api';
import cIconEdit from '@/components/icons/icon-edit.component.vue';
import cIconClose from '@/components/icons/icon-close.component.vue';
import cIconCopy from '@/components/icons/icon-copy.component.vue';
import cIconExcel from '@/components/icons/icon-excel.component.vue';
import cElementWithConfirmation from '@/components/element-with-confirmation/element-with-confirmation.component.vue';

export default defineComponent({
  name: 'cRowActions',
  components: {
    cElementWithConfirmation,
    cIconEdit,
    cIconClose,
    cIconCopy,
    cIconExcel,
  },
  props: {
    showEditAction: {
      type: Boolean,
      default: false,
    },
    showCopyAction: {
      type: Boolean,
      default: false,
    },
    showDeleteAction: {
      type: Boolean,
      default: false,
    },
    showDisableAction: {
      type: Boolean,
      default: false,
    },
    showExcelAction: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const emitEditAction = (): void => {
      context.emit('onEditAction');
    };

    const emitDeleteAction = (): void => {
      context.emit('onDeleteAction');
    };

    const emitDisableAction = (): void => {
      context.emit('onDisableAction');
    };

    const emitCopyAction = (): void => {
      context.emit('onCopyAction');
    };

    const emitExcelAction = (): void => {
      context.emit('onExcelAction');
    };

    return {
      emitCopyAction,
      emitEditAction,
      emitDeleteAction,
      emitDisableAction,
      emitExcelAction,
    };
  },
});
